export default {
  title: 'Confirm your action',
  description: 'Please, confirm the action <b>{name}</b> by entering code from Google Auth app.',
  confirmation: 'Enter the confirmation code',
  confirmation_placeholder: 'XXXXXX',
  btn_submit: 'Confirm',
}
